// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2qawt","itemTitle":"ClientEmergencyInfo_itemTitle__2sKzm","itemText":"ClientEmergencyInfo_itemText__kRI3g"};